 <p-dialog header="'dialog'"
 [style]="{width: '90vw'  }"
 (onHide)="close()" (onShow)='show()' *ngIf="facture" [(visible)]="visible"  >
 <div style="height: 90vh;">
    <app-invoices-participants style="height: 100%;"></app-invoices-participants>

 </div>
 
 
 </p-dialog>
 